var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetamask = function SvgMetamask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m19.252 1-7.495 5.567 1.386-3.285L19.253 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m1.95 1 7.434 5.62-1.318-3.338L1.949 1Zm14.606 12.904-1.997 3.058 4.272 1.175 1.227-4.165-3.502-.068Zm-15.398.068 1.22 4.165 4.272-1.175-1.997-3.058-3.495.068Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m6.408 8.736-1.19 1.8 4.241.189-.15-4.558-2.9 2.57Zm8.385 0-2.938-2.621-.098 4.61 4.233-.188-1.197-1.8ZM6.65 16.962l2.546-1.243-2.2-1.717-.346 2.96Zm5.355-1.243 2.554 1.243-.354-2.96-2.2 1.717Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m14.56 16.962-2.554-1.243.203 1.665-.022.7 2.373-1.122Zm-7.91 0 2.373 1.123-.015-.701.188-1.665-2.546 1.243Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m9.06 12.902-2.124-.625 1.499-.686.625 1.311Zm3.08 0 .626-1.31 1.507.685-2.132.625Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m6.65 16.962.361-3.058-2.358.068 1.997 2.99Zm7.548-3.058.361 3.058 1.996-2.99-2.357-.068Zm1.792-3.367-4.233.188.392 2.177.625-1.31 1.506.685 1.71-1.74Zm-9.054 1.74 1.506-.686.618 1.311.4-2.177-4.242-.188 1.718 1.74Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m5.218 10.537 1.778 3.465-.06-1.725-1.718-1.74Zm9.062 1.74-.075 1.725 1.785-3.465-1.71 1.74Zm-4.82-1.552-.4 2.177.497 2.569.113-3.383-.21-1.363Zm2.297 0-.204 1.356.09 3.39.506-2.569-.392-2.177Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m12.148 12.902-.504 2.569.361.248 2.2-1.717.075-1.725-2.132.625Zm-5.212-.625.06 1.725 2.2 1.717.361-.248-.497-2.569-2.124-.625Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m12.187 18.085.022-.7-.188-.167H9.18l-.173.166.015.7-2.373-1.122.829.678 1.68 1.168h2.884l1.688-1.168.829-.678-2.373 1.123Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m12.005 15.72-.361-.25H9.557l-.361.25-.189 1.664.174-.166h2.84l.188.166-.204-1.665Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m19.569 6.928.64-3.073L19.252 1l-7.246 5.379 2.787 2.357 3.94 1.153.873-1.017-.376-.271.602-.55-.467-.362.603-.46-.4-.3ZM1 3.855l.64 3.073-.406.302.602.46-.46.36.603.55-.376.272.866 1.017 3.94-1.153L9.196 6.38 1.949 1 1 3.855Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.075,
    d: "m18.733 9.889-3.94-1.153 1.198 1.8-1.786 3.466 2.35-.03h3.503l-1.325-4.083ZM6.409 8.736 2.469 9.89l-1.31 4.083h3.495l2.342.03-1.778-3.465 1.19-1.8Zm5.348 1.989.249-4.346 1.145-3.097H8.066l1.13 3.097.264 4.346.09 1.371.007 3.375h2.087l.015-3.375.098-1.371Z"
  })));
};
export default SvgMetamask;